<template>
  <div id="user-manage-detail-personal-information"
       class="mar-b-100">
    <!-- <div class="ipub-h2 line-h-40 relative mar-b-20">
      Personal Information
    </div> -->
    <div class="content-bg"
         style="padding-bottom:12px">
      <div class="ipub-p2 fw-bd mar-b-20">
        <div class="mar-b-20 ipub-h3 line-h-40 ipub-title-tab">
          <span>Basic Information</span>
          <ipub-icon type="iconEditPen"
                     @click="editInfo('basic')"
                     class="content-color ipub-cursor-pointer mar-l-12"
                     v-show="isEdit!=='basic'&&user.codeList&&(user.codeList.includes('USER_MANAGE.MANAGE_USERS.PERSON.EDIT') || user.codeList.includes('USER_MANAGE.MANAGE_USERS.PERSON.EDIT_EXCEPT_EB_RB_GE'))" />
        </div>
        <basicInfo :data="form"
                   ref='basic'
                   @cancel="cancel"
                   @confirm="confirm"
                   :isEdit="isEdit"></basicInfo>
      </div>
      <div class=" ipub-p2 fw-bd mar-b-20">
        <div class="mar-b-20 ipub-h3 line-h-40 ipub-title-tab">
          <span>Information About Display</span>
          <ipub-icon type="iconEditPen"
                     @click="editInfo('display')"
                     class="content-color ipub-cursor-pointer mar-l-12"
                     v-show="isEdit!=='display'&&user.codeList&&user.codeList.includes('USER_MANAGE.MANAGE_USERS.PERSON.DISPLAY.EDIT')" />
        </div>
        <displayInfo :data="form"
                     ref='display'
                     @confirm="confirm"
                     @cancel="cancel"
                     :isEdit="isEdit"></displayInfo>
      </div>
      <div class="ipub-p2 fw-bd mar-b-20"
           v-if="Object.keys(roleArr).includes('Reviewer')">
        <div class="mar-b-20 ipub-h3 line-h-40 ipub-title-tab">
          <span>Specific Information (Reviewer)</span>
          <ipub-icon type="iconEditPen"
                     @click="editInfo('specific')"
                     class="content-color ipub-cursor-pointer mar-l-12"
                     v-show="isEdit!=='specific'&&user.codeList&&user.codeList.includes('USER_MANAGE.MANAGE_USERS.PERSON.REVIEWER.EDIT')" />
        </div>
        <specificInfo :data="form"
                      ref='specific'
                      @confirm="confirm"
                      @cancel="cancel"
                      :isEdit="isEdit"></specificInfo>
      </div>
      <div class="ipub-p2 fw-bd mar-b-20"
           v-if="Object.keys(roleArr).includes('Reviewer Board')">
        <div class="mar-b-20 ipub-h3 line-h-40 ipub-title-tab">
          <span>Specific Information (Reviewer Board)</span>
          <ipub-icon type="iconEditPen"
                     @click="editInfo('specific-rb')"
                     class="content-color ipub-cursor-pointer mar-l-12"
                     v-show="isEdit!=='specific-rb'&&user.codeList&&user.codeList.includes('USER_MANAGE.MANAGE_USERS.PERSON.JOURNAL.EDIT')" />
        </div>
        <specificInfo-rb :data="form"
                         ref='specific-rb'
                         @confirm="confirm"
                         @cancel="cancel"
                         type="rb"
                         :isEdit="isEdit"></specificInfo-rb>
      </div>
      <div class="ipub-p2 fw-bd"
           v-if="Object.keys(roleArr).includes('Editorial Board')">
        <div class="mar-b-20 ipub-h3 line-h-40 ipub-title-tab">
          <span>Specific Information (Editorial Board)</span>
          <ipub-icon type="iconEditPen"
                     @click="editInfo('specific-eb')"
                     class="content-color ipub-cursor-pointer mar-l-12"
                     v-show="isEdit!=='specific-eb'&&user.codeList&&user.codeList.includes('USER_MANAGE.MANAGE_USERS.PERSON.JOURNAL.EDIT')" />
        </div>
        <specificInfo-rb :data="form"
                         ref='specific-eb'
                         :isEdit="isEdit"
                         @confirm="confirm"
                         @cancel="cancel"
                         type="eb"></specificInfo-rb>
      </div>
      <auto-save-confirm :isVisable="isVisable"
                         @cancel="back"
                         @confirm="confirmSave"></auto-save-confirm>
    </div>
    <!-- <template v-if="!isEdit"> -->

    <!-- </template> -->
    <!-- <template v-else> -->

    <!-- </template> -->
    <!-- <AddRank :isVisable="showRank"
             @confirm="confirm"
             @cancel="cancel" />
    <AddDegree :isVisable="showDegree"
               @confirm="confirm"
               @cancel="cancel" /> -->
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
